<template>
    <form-partition title="账单信息">
        <Table
            ref="mt"
            :columns="columns"
            :data="list"
            height="350"
            :loading="loading"
        />
    </form-partition>
</template>
<script>
import { deepCopy } from "_u/helper";
import { renderAmountText } from "@/views/common/u-contract";
export default {
    name: "BillsInfo",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            list: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.list = deepCopy(this.value);
            },
            immediate: true,
        },
    },

    computed: {
        columns() {
            return [
                {
                    key: "title",
                    title: "期数",
                    align: "center",
                    width: 100,
                },
                {
                    key: "period",
                    title: "账期",
                    align: "left",
                    minWidth: 160,
                },
                {
                    key: "bill",
                    title: "账单",
                    align: "left",
                    minWidth: 160,
                    render: (h, params) => {
                        const list = params.row.bill.split("\r\n");
                        return renderAmountText(h, list, "div", "div");
                    },
                },
                {
                    key: "date",
                    title: "应收款日",
                    align: "left",
                    minWidth: 120,
                    render: (h, params) => {
                        return h(
                            "span",
                            {
                                style: {
                                    whiteSpace: "pre-wrap",
                                },
                                domProps: {
                                    title: params.row.date,
                                },
                            },
                            params.row.date
                        );
                    },
                },
            ];
        },
    },

    created() {},
    methods: {},
};
</script>
<style lang="less" scoped></style>
